import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Position Field Icons
// =============================================================================

export function Anchor(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "Anchor",
    viewBox: "0 0 24 24",
    path: (
      <>
        <path
          d="M12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M12 8v14M5 12h14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className="icon-outline"
        />
        <path
          d="M5 21a7 7 0 0 1 7-7 7 7 0 0 1 7 7"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function Layers(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "Layers",
    viewBox: "0 0 24 24",
    path: (
      <path
        d="M12 2L2 7l10 5 10-5-10-5ZM2 17l10 5 10-5M2 12l10 5 10-5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
